'use strict';

import angular from 'angular';

function MemberResource($resource) {
  return $resource('/api/groups/:groupId/members/:id/:controller', {
    groupId: '@groupId', id: '@id'
  }, {
    queryReport: {
      method: 'GET',
      isArray: true,
      params: { controller: 'report' }
    },
    queryHistoricalReport: {
      method: 'GET',
      isArray: true,
      params: { controller: 'historicalreport' }
    },
    queryContactReport: {
      method: 'GET',
      isArray: true,
      params: { controller: 'contactreport' }
    },
    queryFullReport: {
      method: 'GET',
      isArray: true,
      params: { controller: 'fullreport' }
    },
    update: {
      method: 'PUT'
    },
    updatePerson: {
      method: 'PUT',
      params: { controller: 'person' }
    },
    deactivate: {
      method: 'PUT',
      isArray: true,
      params: { controller: 'deactivate' }
    },
    reactivate: {
      method: 'PUT',
      params: { controller: 'reactivate' }
    }
  });
}

MemberResource.$inject = ['$resource'];

export default angular.module('georgeApp.memberSvc', [])
  .factory('MemberSvc', MemberResource)
  .name;
